import { fromJS } from 'immutable';
import {
    getRevisionViewID,
    RevisionViewState,
    RevisionViewStateImmutable,
} from 'phoenix2/components/views/revision/revision-types';

export const UPDATE_VIEWSTATE = 'UPDATE_VIEWSTATE';
export const SET_VIEWSTATE = 'SET_VIEWSTATE';
export const SYNC_AND_SELECT_PACKAGE = 'SYNC_AND_SELECT_PACKAGE';
export const SELECT_PACKAGE = 'SELECT_PACKAGE';
export const SYNC_PACKAGE = 'SYNC_PACKAGE';
export const SELECT_TASK = 'SELECT_TASK';
export const SET_CURRENT_TASK = 'SET_CURRENT_TASK';
export const SELECT_TASK_ITEM = 'SELECT_TASK_ITEM';
export const SELECT_NEXT_TASK_ITEM = 'SELECT_NEXT_TASK_ITEM';
export const SELECT_NEXT_TASK = 'SELECT_NEXT_TASK';
export const TASK_VIEW_OPENED = 'TASK_VIEW_OPENED';

export function updateViewState(viewId: string, update: any) {
    return { type: UPDATE_VIEWSTATE, viewId, update };
}

export function setViewState(viewId: string, viewState: any) {
    return { type: SET_VIEWSTATE, viewId, viewState };
}

export function syncAndSelectPackage(viewId: string, packageId: string, selected = true) {
    return { type: SYNC_AND_SELECT_PACKAGE, viewId, packageId, selected };
}

export function selectPackage(viewId: string, packageId: string, selected = true) {
    return { type: SELECT_PACKAGE, viewId, packageId, selected };
}

export function syncPackage(packageId: string) {
    return { type: SYNC_PACKAGE, packageId };
}

export function selectTask(taskId: string, options = {}) {
    return { type: SELECT_TASK, taskId, options };
}

export function selectTaskItem(item: any, jumpToStage = undefined) {
    return { type: SELECT_TASK_ITEM, item, jumpToStage };
}

export function selectNextTaskItem(taskId: string) {
    return { type: SELECT_NEXT_TASK_ITEM, taskId };
}

export function selectNextTask(filter: string) {
    return { type: SELECT_NEXT_TASK, filter };
}

export function taskViewOpened() {
    return { type: TASK_VIEW_OPENED };
}

export function updateRevisionViewstate(
    update: RevisionViewState,
): {
    type: typeof UPDATE_VIEWSTATE;
    viewId: string;
    update: RevisionViewStateImmutable;
} {
    return {
        type: UPDATE_VIEWSTATE,
        viewId: getRevisionViewID(update.page),
        update: fromJS(update),
    };
}
